import { General } from './General/General'
import { Facilities } from './Facilities/Facilities'
import Users from './Users/Users'

export const contractCategoryDetailsRoute = {
  general: 'general',
  users: 'users',
  facilities: 'facilities'
}

export const contractCategoryDetailsRoutes = [
  {
    path: contractCategoryDetailsRoute.general,
    component: General
  },
  {
    path: contractCategoryDetailsRoute.facilities,
    component: Facilities
  },
  {
    path: contractCategoryDetailsRoute.users,
    component: Users
  }
]

export const CONTRACT_CATEGORY_DETAILS_TABS = [
  {
    key: contractCategoryDetailsRoute.general,
    label: 'General'
  },
  {
    key: contractCategoryDetailsRoute.facilities,
    label: 'Facilities'
  },
  {
    key: contractCategoryDetailsRoute.users,
    label: 'Users'
  }
]
